import React from 'react';
import { classes, getValidChildren } from '../../../lib';
import { Stroke } from '../Persona';
import Styles from './PrivacySection.module.less';
import { AnimatedStroke } from '../AnimatedStroke/AnimatedStroke';

export type PrivacySectionProps = {
    title: string;
    stroke?: Stroke;
    children: React.ReactNode;
};

export const PrivacySection = (p: PrivacySectionProps): JSX.Element => {
    const [firstItem, secondItem, thirdItem] = getValidChildren(p.children);
    return (
        <div
            className={classes(
                'td-horizontal m-vertical stretch-top g40 td-py56 m-py20 wrap lp-section',
                Styles.container
            )}>
            <h3 className={classes('flex alude-gray-8', Styles.title)}>
                {p.title}
                {p.stroke && <AnimatedStroke stroke={p.stroke} />}
            </h3>
            <div className="vertical stretch-top td-g40 m-g20 flex">
                <div className="horizontal stretch-top g20">
                    {firstItem}
                    {secondItem}
                </div>
                <div className="horizontal stretch-top g20">{thirdItem}</div>
            </div>
        </div>
    );
};
